export const FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER =
  "FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER";
export const FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER_FAILURE =
  "FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER_FAILURE";
export const FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER_SUCCESS =
  "FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER_SUCCESS";
export const RESET_TRACKED_ASSEMBLY_GUIDE = "RESET_TRACKED_ASSEMBLY_GUIDE";
